import { Component, HostListener, OnDestroy, OnInit } from "@angular/core";
import { FormControl, FormGroup, ValidationErrors, Validators } from "@angular/forms";
import { Store } from "@ngrx/store";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { Observable, Subscription, filter } from "rxjs";
import { AppState } from "src/app/store/app.reducer";
import { selectExportedMtmaDevice, selectUpdatedMtmaExportDevice } from "src/app/store/user-file/user-file.selector";
import * as UserFileActions from 'src/app/store//user-file/user-file.actions';
import { StandardNewValidator, StandardPageLayout } from "src/app/modules/shared/stdlayoutlib/classes.stdlayoutlib";
import { ExportInfo } from "src/app/model/export";
import { selectIsImpersMode } from "src/app/store/user/user.selector";

@Component({
	templateUrl: './mtma-export-dialog.component.html',
})

export class MtmaExportDeviceDialogComponent implements OnInit, OnDestroy {
	isImpersMode$: Observable<boolean | undefined>;
	isImpersModeSub: Subscription | undefined;
	isImpersMode: boolean;
	// filesForm: FormGroup;

	exportForm: FormGroup;

	update$: Observable<boolean | undefined>;
	updateSub: Subscription;

	export$: Observable<boolean | undefined>;
	exportSub: Subscription;

	exportInfo: ExportInfo;
	update: boolean;

	// design
	screenWidth: number;
	MIN_MD_WIDTH = 500;
	DELTA_ERROR_PIXEL = 7;
	MIN_TWO_BUTTONS_DIALOG_WIDTH = 575 + this.DELTA_ERROR_PIXEL;

	constructor(
		private store: Store<AppState>,
		private ref: DynamicDialogRef,
		public config: DynamicDialogConfig
	) {
		if (config.data !== undefined && config.data.exportInfo !== undefined) {
			this.exportInfo = config.data.exportInfo;
			this.update = true;
		} else {
			this.exportInfo = new ExportInfo('', '');
			this.update = false;
		}
		this.initSelectors();
	}

	ngOnInit(): void {
		this.subscribeAll();
		this.buildForm();
		this.onResize();

		StandardNewValidator.setFirstCompile(true);
	}

	ngOnDestroy(): void {
		this.updateSub?.unsubscribe();
		this.exportSub?.unsubscribe();
		this.isImpersModeSub?.unsubscribe();
	}

	initSelectors(): void {
		this.export$ = this.store.select(selectExportedMtmaDevice);
		this.update$ = this.store.select(selectUpdatedMtmaExportDevice);
		this.isImpersMode$ = this.store.select(selectIsImpersMode);
	}

	buildForm(): void {
		this.exportForm = new FormGroup({
			'name': new FormControl(this.exportInfo.Name, [Validators.required, Validators.minLength(5)]),
		});
	}

	subscribeAll(): void {
		this.updateSub = this.update$?.subscribe(
			(res) => {
				if (res) {
					this.closeDialog();
				}
			}
		);
		this.exportSub = this.export$?.pipe(filter(res => !!res)).subscribe(
			(res) => {
				if (res) {
					this.closeDialog();
				}
			}
		);
		this.isImpersModeSub = this.isImpersMode$?.subscribe(
			(isImpersMode) => {
				this.isImpersMode = isImpersMode;
			}
		);
	}

	get f(): any {
		return this.exportForm.controls;
	}

	getFormValidationErrors(): boolean {
		let atLeastOneError = false;
		Object.keys(this.exportForm.controls).forEach(key => {
			const controlErrors: ValidationErrors = this.exportForm.get(key).errors;
			if (controlErrors != null) {
				/* Object.keys(controlErrors).forEach(keyError => {
					console.log('Key control: ' + key + ', keyError: ' + keyError + ', err value: ', controlErrors[keyError]);
				}); */
				atLeastOneError = true;
			}
		});
		return atLeastOneError;
	}

	submit(): void {
		StandardNewValidator.setFirstCompile(false);
		if (!this.getFormValidationErrors()) {
			this.save();
		}
	}

	save(): void {
		const exportInfo = new ExportInfo(this.exportForm.value.name, undefined);
		exportInfo.Backup = undefined;
		if (this.update) {
			this.store.dispatch(UserFileActions.updateMtmaExportDevice({ exportId: this.exportInfo.Id, exportInfo: exportInfo, isImpersMode: this.isImpersMode }));
		} else {
			exportInfo.Backup = false;
			this.store.dispatch(UserFileActions.exportMtmaDevice({ exportInfo: exportInfo, isImpersMode: this.isImpersMode }));
		}
	}

	closeDialog(): void {
		this.ref.close();
	}

	@HostListener('window:resize')
	onResize() {
		this.screenWidth = window.innerWidth;
	}

	onExtendedMobile(): boolean {
		return StandardPageLayout.onExtendedMobile(this.screenWidth);
	}

	dynamicButtonWidth(): string {
		return StandardPageLayout.dynamicButtonWidth(this.screenWidth);
	}

	dynamicInputTextWidth(): string {
		return StandardPageLayout.dynamicInputTextWidth(this.screenWidth, 'w-30rem');
	}

	justifyContentStyle(): string {
		return StandardNewValidator.justifyMessagesNewValidator(this.screenWidth);
	}

	newShowErrors(type: MtmaExportDeviceDialogComponent['f'], classType: string): string {
		return StandardNewValidator.newShowErrors(type, classType, this.screenWidth);
	}

	showErrorRequiredMessage(type: MtmaExportDeviceDialogComponent['f']): boolean {
		return StandardNewValidator.showErrorRequiredMessage(type);
	}

	customPaddingX(): string {
		return StandardPageLayout.customPaddingX(this.screenWidth);
	}
}